import { Component, OnInit, Input } from '@angular/core';
import { CardListCell } from 'src/app/components/pages-partials/card-list/card-list-cell';
import { TranslatePipe } from '@ngx-translate/core';

export interface MenuItem {
  label: string;
  action: Function;
}

@Component({
    selector: 'app-download-csv-menu',
    templateUrl: './dynamic-data-list-csv.component.html',
    styleUrls: ['./dynamic-data-list-csv.component.scss'],
    providers: [TranslatePipe],
    standalone: false
})
export class DynamicDataListCsvComponent {
  @Input() cellProps: CardListCell[];
  @Input() items: any[];
  @Input() filename: string;

  itemClick() {   
      const separator: string = ';';
      const lineEnding: string = '\n';
      const lineEndingMarks = /(\r\n|\n|\r)/gm;
      const csvContent = this.cellProps.map(column => column.title.replace(':','') ?? '').join(separator) + lineEnding +
        this.items.map(row => this.cellProps.map(column  => {
          // if(typeof column === Number) 
          // return column;
        
          return column.csvResolver(row)?.replace(lineEndingMarks, "");

        }).join(separator)).join(lineEnding);
  
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
  
      let anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = this.filename + '.csv';
      // start download/save
      anchor.click();
      URL.revokeObjectURL(url);
      anchor.remove();
    }
  }

